export function worksStickyNav() {
    const stickyNav = $('.our-work-nav');
    const header = $(".header");
    const headerHeight = header.innerHeight();
    const stickyNavItem = $('.our-work-nav li');
    const sections = $('.our-work-item');
    let scrollTop;
    let topIndent = 30;


    function sticky() {
        if (window.innerWidth > 1023) {
            scrollTop = $(window).scrollTop();
            sections.each(function (index, section) {
                let $this = $(section);
                let itemOffsetTop = $this.offset().top;
                if (scrollTop + headerHeight + topIndent >= itemOffsetTop) {
                    let attr = $this.attr("id");
                    if (!$this.hasClass("active")) {
                        $this.addClass('active');
                        if (stickyNav.find('a[href="#' + attr + '"]').length) {
                            stickyNav.find('a[href="#' + attr + '"]').parent().addClass("active").prev().addClass("prev");
                        }
                    }
                } else {
                    $this.removeClass('active');
                    let attr = $this.attr("id");
                    if (stickyNav.find('a[href="#' + attr + '"]').length) {
                        stickyNav.find('a[href="#' + attr + '"]').parent().removeClass("active").prev().removeClass("prev");
                    }
                }
            });
        } else {
            stickyNavItem.removeClass('active prev');
        }
    }

    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/worksStickyNav.js